/**
 * Favorited photos filter enum values.
 *
 * @type {{ALL: string, MEMBERS: string, OWNED: string}}
 */
const FAVORITED_PHOTOS_FILTER = {
  ALL: 'ALL',
  OWNED: 'OWNED',
  MEMBERS: 'MEMBERS',
};

const FAVORITED_PHOTOS_FILTER_LABELS = {
  [FAVORITED_PHOTOS_FILTER.ALL]: 'All',
  [FAVORITED_PHOTOS_FILTER.OWNED]: 'My favorites',
  [FAVORITED_PHOTOS_FILTER.MEMBERS]: 'Member Favorites',
};

const MATCHED_PHOTOS_SORT = {
  BEST_SCORE: 'BEST_SCORE',
  MOST_RECENT: 'MOST_RECENT',
  LEAST_RECENT: 'LEAST_RECENT',
  MOST_RECENT_UPLOAD: 'MOST_RECENT_UPLOAD',
  LEAST_RECENT_UPLOAD: 'LEAST_RECENT_UPLOAD',
};

export {
  FAVORITED_PHOTOS_FILTER,
  FAVORITED_PHOTOS_FILTER_LABELS,
  MATCHED_PHOTOS_SORT,
};
